import createReducer from '../../utils/createReducer';
import actions from './actions';

export const initialState = {
    boardId: null,
    count: 0,
    error: false,
    loading: true, // init with loading true even though no fetches have been made to provider component logic
    text: ''
};

const actionHandlers = {};

actionHandlers[actions.FETCH_COUNT_START] = (state, {payload}) => {
    const {boardId} = payload;
    return {
        loading: true,
        boardId
    };
};

actionHandlers[actions.FETCH_COUNT_SUCCESS] = (state, {payload}) => {
    const {collaboratorCount, collaboratorText, tripBoardUuid} = payload.apiData;
    return {
        boardId: tripBoardUuid,
        count: collaboratorCount,
        error: false,
        loading: false,
        text: collaboratorText
    };
};

actionHandlers[actions.FETCH_COUNT_ERROR] = (state) => {
    return {
        boardId: state.boardId,
        error: true,
        loading: false
    };
};

export default createReducer(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/reducer-count.js